module.exports = __webpack_public_path__ + "img/Capture11.1a6702d0.jpg";